<template>
  <div id="reselling_dashboard">
    <h3>Reselling</h3>
    <div class="backdrop" v-if="isLoading">
      <moon-loader :loading="isLoading" size="21px" color="#007bff" />
    </div>

    <div class="row">
      <div class="outer-box max-width-100 mx-auto" style="max-width: 1200px">
        <h4>Location Subscriptions Details</h4>
        <div class="inner-box" style="text-align: left; width: auto">
          <input
            class="hl_input--wrap"
            type="text"
            placeholder="Enter Location ID"
            v-model="locationId"
          />
        </div>
        <div>
          <button
            class="btn btn-primary unsub-btn"
            @click="getLocationSubscriptions()"
            :disabled="isLoading || locationId.trim() == ''"
          >
            <span>Get Location Subscriptions </span>
          </button>
        </div>
        <b-table
          class="mt-3"
          :items="subscriptions"
          :sticky-header="true"
          :fields="fields"
          hover
          responsive
          bordered
          striped
        >
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
        </b-table>
      </div>
    </div>
    <div class="row">
      <div class="outer-box" style="width: 664px">
        <h4>Unsubscribe Product</h4>
        <div class="inner-box">
          <input
            class="hl_input--wrap"
            type="text"
            placeholder="Enter Location ID"
            v-model="locationId"
          />
          <input
            class="hl_input--wrap mt-3"
            type="text"
            placeholder="Enter Subscription ID"
            v-model="subscriptionId"
          />

          <p v-if="error" class="error mt-3">
            {{ error }}
          </p>
          <p v-if="successMessage" class="success-text mt-3">
            {{ successMessage }}
          </p>

          <button
            class="btn btn-primary unsub-btn mt-3"
            @click="unsubscribe()"
            :disabled="isLoading || locationId.trim() == '' || subscriptionId.trim() == ''"
          >
            <span>Unsubscribe Product</span>
          </button>
        </div>
      </div>
    </div>
    <div class="separator"></div>
    <div class="row">
      <div class="outer-box max-width-100 mx-auto" style="max-width: 1200px">
        <h4>Company Subscriptions Details</h4>
        <div class="inner-box" style="text-align: left; width: auto">
          <input
            class="hl_input--wrap"
            type="text"
            placeholder="Enter Company ID"
            v-model="companyId"
          />
        </div>
        <div>
          <button
            class="btn btn-primary unsub-btn"
            @click="getCompanySubscriptions()"
            :disabled="isLoading || companyId.trim() == ''"
          >
            <span>Get Company Subscriptions </span>
          </button>
        </div>
        <b-table
          class="mt-3"
          :items="companySubscriptions"
          :sticky-header="true"
          :fields="companyFields"
          hover
          responsive
          bordered
          striped
        >
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
        </b-table>
      </div>
    </div>
    <div class="row">
      <div class="outer-box" style="width: 664px">
        <h4>Unsubscribe Product</h4>
        <div class="inner-box">
          <input
            class="hl_input--wrap"
            type="text"
            placeholder="Enter Company ID"
            v-model="companyId"
          />
          <input
            class="hl_input--wrap mt-3"
            type="text"
            placeholder="Enter Subscription ID"
            v-model="companySubscriptionId"
          />

          <p v-if="companyError" class="error mt-3">
            {{ companyError }}
          </p>
          <p v-if="successMessageForCompany" class="success-text mt-3">
            {{ successMessageForCompany }}
          </p>

          <button
            class="btn btn-primary unsub-btn mt-3"
            @click="unsubscribeCompany()"
            :disabled="isLoading || companyId.trim() == '' || companySubscriptionId.trim() == ''"
          >
            <span>Unsubscribe Product</span>
          </button>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="outer-box" style="width: 664px">
        <h4>Convert Purchase Style from LOCATION_PURCHASE to COMPANY_DIRECT_PURCHASE</h4>
        <div class="inner-box">
          <input
            class="hl_input--wrap"
            type="text"
            placeholder="Enter Location ID"
            v-model="locationId"
          />
          <input
            class="hl_input--wrap mt-3"
            type="text"
            placeholder="Enter Subscription ID"
            v-model="subscriptionId"
          />

          <input
            class="hl_input--wrap mt-3"
            type="text"
            placeholder="Enter Reason for Conversion"
            v-model="subscriptionConversionReason"
          />

          <p v-if="lcToCDPError" class="error mt-3">
            {{ lcToCDPError }}
          </p>
          <p v-if="successMessage" class="success-text mt-3">
            {{ successMessage }}
          </p>

          <button
            class="btn btn-primary lc-cdp-btn mt-3"
            @click="convertLPtoCDP()"
            :disabled="
              isLoading ||
              locationId.trim() == '' ||
              subscriptionId.trim() == '' ||
              subscriptionConversionReason.trim() == ''
            "
          >
            <span> Convert To CDP </span>
          </button>
        </div>
      </div>
    </div>

    <div class="separator"></div>
    <div class="row">
      <div class="outer-box max-width-100 mx-auto" style="max-width: 1400px">
        <h4>Unsubscribed Locations Recovery</h4>
        <div class="inner-box" style="text-align: left; width: auto">
          <input
            class="hl_input--wrap"
            type="text"
            placeholder="Enter Company Subscription ID"
            v-model="oldCompanySubscriptionId"
          />
        </div>
        <div>
          <button
            class="btn btn-primary unsub-btn"
            @click="getUnsubscribedLocations()"
            :disabled="isLoading || oldCompanySubscriptionId.trim() == ''"
          >
            <span>Get Unsubscribed Locations</span>
          </button>
        </div>

        <div v-if="subscriptionData" class="subscription-info mt-3 mb-3">
          <h5>Subscription Details</h5>
          <div class="info-grid">
            <div class="info-item">
              <span class="label">Product Code:</span>
              <span class="value">{{ subscriptionData.productCode }}</span>
            </div>
            <div class="info-item">
              <span class="label">Status:</span>
              <span class="value">{{ subscriptionData.deleted ? "Deleted" : "Active" }}</span>
            </div>
            <div class="info-item">
              <span class="label">Created At:</span>
              <span class="value">{{ new Date(subscriptionData.createdAt).toLocaleString() }}</span>
            </div>
            <div class="info-item">
              <span class="label">Payment Provider:</span>
              <span class="value">{{ subscriptionData.paymentProvider }}</span>
            </div>
          </div>
        </div>

        <b-table
          class="mt-3"
          :items="unsubscribedLocations"
          :sticky-header="true"
          :fields="unsubscribedFields"
          hover
          responsive
          bordered
          striped
        >
          <template #cell(actions)="row">
            <button
              v-if="!row.item.recoveredToSubscriptionId"
              class="btn btn-primary btn-sm"
              @click="resubscribeLocation(row.item)"
              :disabled="isLoading"
            >
              Recover
            </button>
            <span v-else class="success-text">
              Recovered (ID: {{ row.item.recoveredToSubscriptionId }})
            </span>
          </template>
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
import { ResellingService } from "@/services";

export default {
  data: function () {
    return {
      isLoading: false,
      locationId: "",
      companyId: "",
      subscriptionId: "",
      companySubscriptionId: "",
      oldCompanySubscriptionId: "",
      subscriptionConversionReason: "",
      error: undefined,
      lcToCDPError: undefined,
      companyError: undefined,
      successMessage: "",
      successMessageForCompany: "",
      subscriptions: null,
      companySubscriptions: null,
      unsubscribedLocations: [],
      subscriptionData: null,
      unsubscribedFields: [
        { key: "consumer", label: "Consumer" },
        { key: "consumerId", label: "Consumer ID" },
        { key: "purchaseStyle", label: "Purchase Style" },
        { key: "beneficiaryId", label: "Beneficiary ID" },
        { key: "subscriptionId", label: "Subscription ID" },
        { key: "actions", label: "Actions" },
      ],
      fields: [
        { key: "subscriptionId", label: "subscriptionId" },
        { key: "quantity", label: "quantity" },
        { key: "amount", label: "amount" },
        { key: "paymentStatus", label: "Payment Status" },
        { key: "productCode", label: "Product Code" },
        { key: "purchaseStyle", label: "Purchase Style" },
      ],
      companyFields: [
        { key: "subscriptionId", label: "subscriptionId" },
        { key: "quantity", label: "quantity" },
        { key: "amount", label: "amount" },
        { key: "paymentStatus", label: "Payment Status" },
        { key: "productCode", label: "Product Code" },
        { key: "planId", label: "Plan Id" },
        { key: "purchaseStyle", label: "Purchase Style" },
      ],
    };
  },
  components: {},
  methods: {
    async convertLPtoCDP() {
      this.isLoading = true;
      this.lcToCDPError = undefined;
      this.successMessage = "";
      try {
        this.isLoading = true;
        await ResellingService.convertSubscriptionFromLPtoCDP(
          this.locationId,
          this.subscriptionId,
          this.subscriptionConversionReason
        );

        this.successMessage = "Successfully Converted to CDP";
        this.isLoading = false;
      } catch (err) {
        this.isLoading = false;
        this.lcToCDPError = err.response.data.message;
      }
    },

    async unsubscribe() {
      this.isLoading = true;
      this.error = undefined;
      this.successMessage = "";
      try {
        this.isLoading = true;
        await ResellingService.cancelSubscriptionForLocation(this.locationId, this.subscriptionId);
        // refectch subscriptions after unsubscribing only if subscriptions were fetched previously
        if (this.subscriptions) {
          this.getLocationSubscriptions();
        }
        this.successMessage = "Successfully Unsubscribed";
        this.isLoading = false;
      } catch (err) {
        console.error(err);
        this.isLoading = false;
        this.error = err.response.data.message;
      }
    },

    async getLocationSubscriptions() {
      this.isLoading = true;
      this.subscriptions = null;
      ResellingService.getSubscriptionsForLocation(this.locationId)
        .then((res) => {
          this.isLoading = false;
          this.subscriptions = res.data;
        })
        .catch((err) => {
          console.error(err);
          this.isLoading = false;
        });
    },

    async getCompanySubscriptions() {
      this.isLoading = true;
      this.companySubscriptions = null;
      ResellingService.getSubscriptionsForCompany(this.companyId)
        .then((res) => {
          this.isLoading = false;
          this.companySubscriptions = res.data;
        })
        .catch((err) => {
          console.error(err);
          this.isLoading = false;
        });
    },

    async unsubscribeCompany() {
      this.isLoading = true;
      this.companyError = undefined;
      this.successMessageForCompany = "";
      try {
        this.isLoading = true;
        await ResellingService.cancelSubscriptionForCompany(
          this.companyId,
          this.companySubscriptionId
        );
        if (this.companySubscriptions) {
          this.getCompanySubscriptions();
        }
        this.successMessageForCompany = "Successfully Unsubscribed";
        this.isLoading = false;
      } catch (err) {
        console.error(err);
        this.isLoading = false;
        this.companyError = err.response.data.message;
      }
    },

    async getUnsubscribedLocations() {
      this.isLoading = true;
      this.unsubscribedLocations = [];
      try {
        const {
          data: { beneficiaries, subscriptionData },
        } = await ResellingService.getUnsubscribedLocations(this.oldCompanySubscriptionId);

        this.unsubscribedLocations = beneficiaries;
        this.subscriptionData = subscriptionData;
      } catch (err) {
        console.error(err);
        this.error = err.response?.data?.message || "Failed to fetch unsubscribed locations";
      } finally {
        this.isLoading = false;
      }
    },

    async resubscribeLocation(location) {
      this.isLoading = true;
      try {
        const response = await ResellingService.resubscribeLocations(
          this.oldCompanySubscriptionId,
          [location.beneficiaryId]
        );

        // Update the location with new subscription ID
        const index = this.unsubscribedLocations.findIndex(
          (l) => l.beneficiaryId === location.beneficiaryId
        );
        if (index !== -1) {
          this.unsubscribedLocations[index].recoveredToSubscriptionId = response.data.results.find(
            (r) => r.beneficiaryId === location.beneficiaryId
          ).newSubscriptionId;
        }

        this.successMessage = "Successfully resubscribed location";
      } catch (err) {
        console.error(err);
        this.error = err.response?.data?.message || "Failed to resubscribe location";
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#reselling_dashboard {
  position: relative;
  .checklist {
    padding: 20px;
  }

  .subscription-info {
    background: #f8f9fa;
    border-radius: 4px;
    padding: 15px;

    h5 {
      margin-bottom: 15px;
      color: #495057;
    }

    .info-grid {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
      gap: 15px;
    }

    .info-item {
      .label {
        font-weight: 600;
        color: #6c757d;
        margin-right: 8px;
      }
      .value {
        color: #212529;
      }
    }
  }

  .unsub-btn {
    display: grid;
    grid-template-columns: 1fr auto;
    grid-gap: 10px;
    margin: auto;
  }
  .error {
    color: #e53716 !important;
    font-style: italic !important;
  }
  .warn {
    color: #ffc107;
  }
  .success-text {
    color: #28a745;
    font-style: italic;
    margin: 10px;
  }

  .subscription_details {
    text-align: left;
    display: grid;
    justify-content: center;
    grid-gap: 20px;
    padding-top: 40px;
    width: 100%;
    overflow-x: auto;
  }

  .fixed-table {
    table-layout: fixed;
    width: 100%;
    border-collapse: collapse;
  }

  .backdrop {
    position: fixed;
    top: 0px;
    left: 0;
    width: 100%;
    height: 100%;
    background: #ffffffa1;
    z-index: 100;
    display: grid;
    justify-content: center;
    align-items: center;
  }
  .separator {
    border-bottom: 2px solid #dbdee2;
    margin-top: 24px;
  }

  :deep(.b-table-sticky-header) {
    max-height: 600px !important;
  }
}
</style>
